import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  tabindex: "-1"
}
const _hoisted_2 = {
  key: 0,
  class: "InLineSearch",
  tabindex: "-1"
}
const _hoisted_3 = {
  key: 1,
  class: "InLineSearch"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Suggestions = _resolveComponent("Suggestions")!
  const _component_Disciplines = _resolveComponent("Disciplines")!

  return (_ctx.showResultsTab)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.dependencyReady)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createCommentVNode(" <TabsManager>\n\t\t\t\t<template v-slot:content>\n\t\t\t\t\t<Programmes\n\t\t\t\t\t\tv-if=\"selectedTab === TabsKind.PROGRAMMES\"\n\t\t\t\t\t\tv-show=\"!hasNoResults\"\n\t\t\t\t\t/>\n\t\t\t\t\t<SearchingFor v-if=\"selectedTab === TabsKind.SEARCHING_FOR\" />\n\t\t\t\t</template>\n\t\t\t</TabsManager> "),
              _createVNode(_component_Suggestions)
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_Disciplines)
      ]))
}